<template>
  <div>
    <b-row>
      <b-col>
        <b-table
          v-if="isLoaded"
          ref="work-order-incentive-report-table"
          :items="records"
          :fields="columns"
          :busy="isLoadingData"
          :sort-by.sync="sorting.sortBy"
          :sort-desc.sync="sorting.sortDesc"
          @sort-changed="handleSortingChanged"
          no-local-sorting
          show-empty
          responsive
          table
        >
          <template #cell(technician_name)="data">
            <b-link :to="{ name: 'user', params: { id: data.item.technician_id } }">
              {{ data.item.technician_name }}
            </b-link>
          </template>

          <template #cell(total_revenue_cents)="data">
            <money-format
              :value="Number(data.item.total_revenue_cents)"
              subunits-value
            />
          </template>

          <template #cell(referral_work_orders_count)="data">
            <div>
              {{ data.item.referral_work_orders_count | numberWithDelimeter }}
            </div>
            <div class="font-size-sm text-secondary">
              <money-format
                :value="Number(data.item.referral_revenue_cents)"
                subunits-value
              />
            </div>
          </template>

          <template #cell(total_work_orders_completed)="data">
            {{ data.item.total_work_orders_completed | numberWithDelimeter }}
          </template>

          <template #cell(referral_incentive_cents)="data">
            <money-format
              v-if="Number(data.item.referral_incentive_cents) > 0"
              :value="Number(data.item.referral_incentive_cents)"
              subunits-value
            />
          </template>

          <template #cell(weekend_incentive_cents)="data">
            <money-format
              v-if="Number(data.item.weekend_incentive_cents) > 0"
              :value="Number(data.item.weekend_incentive_cents)"
              subunits-value
            />
          </template>

          <template #cell(revenue_tier_incentive_cents)="data">
            <money-format
              v-if="Number(data.item.revenue_tier_incentive_cents) > 0"
              :value="Number(data.item.revenue_tier_incentive_cents)"
              subunits-value
            />
          </template>

          <template #cell(incentive_payout_cents)="data">
            <money-format
              :value="Number(data.item.incentive_payout_cents)"
              subunits-value
            />
          </template>
        </b-table>
        <sfs-skeleton-table
          v-else
          :rows="pagination.perPage"
          :columns="columns.length"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col
        cols="auto"
        :class="{ 'mr-auto': true, 'ml-auto': !showPerPage }"
      >
        <b-pagination
          v-if="showPagination"
          v-model="pagination.currentPage"
          :total-rows="pagination.maxResults > totalRows ? totalRows : pagination.maxResults"
          :per-page="pagination.perPage"
          last-class="d-none"
        />
      </b-col>
      <sfs-pagination-dropdown
        v-if="showPerPage"
        container-class="col-auto"
        :current-page="pagination.currentPage"
        :per-page="pagination.perPage"
        :total-rows="totalRows"
        @per-page-changed="onPerPageChanged"
      />
    </b-row>
  </div>
</template>

<script>
import urlMixin from '@/mixins/urlMixin';
import tableMixin from '@/mixins/tableMixin';
import { WORK_ORDER_INCENTIVE_REPORT_TABLE_DEFAULT_COLUMNS } from '@/constants/reports';

export default {
  name: 'WorkOrderIncentiveReportTable',
  mixins: [urlMixin, tableMixin],
  props: {
    columns: {
      type: Array,
      default: () => WORK_ORDER_INCENTIVE_REPORT_TABLE_DEFAULT_COLUMNS,
    },
  },
  methods: {
    getRecords() {
      this.isLoadingData = true;
      this.$analyticsAPI
        .getWorkOrderIncentiveReport(this.params)
        .then(({ total, records }) => {
          this.totalRows = total;
          this.records = records;
        })
        .catch(() => {
          this.records = [];
        })
        .finally(() => {
          this.loaded = true;
          this.isLoadingData = false;
          this.$emit('data-changed', this.records);
        });
    },
  },
};
</script>
